export function safeLocationReplace(url) {
  const hook = window.__howler_location_replace__;
  if (typeof hook === 'function') {
    hook(url);
    return;
  }

  try {
    window.location.replace(url);
  } catch (e) {
    // jsdom can throw "Not implemented: navigation" for location changes.
    // In production browsers this won't happen; for tests we allow a hook.
    throw e;
  }
}

export function safeLocationReload() {
  const hook = window.__howler_location_reload__;
  if (typeof hook === 'function') {
    hook();
    return;
  }

  window.location.reload();
}
